/* eslint-disable class-methods-use-this */
import { BrandDto } from '../dtos/brand-dto';
import Brand from '../models/brand';

export default class BrandMapping {
  getBrandResponse(data: BrandDto): Brand {
    return {
      code: data.codigo,
      apesegCode: data.codigoApeSeg,
      description: data.descripcion,
    };
  }

  formatBrandRequest(data: Brand): BrandDto {
    return {
      codigo: data.code,
      descripcion: data.description,
      codigoApeSeg: data.apesegCode,
    };
  }
}
